
<div class="hbox">
  <div class="tickets">
    <div class="flex justifySB">
      <div class="title">Support Ticket</div>
      <div class="flex gap-12">
        <div>
          <label class="custom-checkbox">
            <input 
              type="radio" 
              name="ticketFilter" 
              (change)="changeFilter('All')"
              [checked]=""
            />
            <span class="checkmark"></span>
            <span>All</span>
          </label>
        </div> 
        <div>
          <label class="custom-checkbox">
            <input 
              type="radio" 
              name="ticketFilter" 
              (change)="changeFilter('Active')"
              [checked]="true"
            />
            <span class="checkmark"></span>
            <span>Active</span>
          </label>
        </div> 
        <div>
          <label class="custom-checkbox">
            <input 
            type="radio" 
            name="ticketFilter" 
            (change)="changeFilter('Completed')" 
            [checked]="" />
            <span class="checkmark"></span>
            <span>Closed</span>
          </label>
        </div>
        <div>
          <label class="custom-checkbox">
            <input 
            type="radio"
            name="ticketFilter" 
            (change)="changeFilter('Spam')" 
            [checked]="" />
            <span class="checkmark"></span>
            <span>Spam</span>
          </label>
        </div>
      </div>
    </div>
    <div class="ticket-list" style="overflow-x: hidden">
      <div class="ticket justifySB bdr-btm" *ngFor="let ticket of supportTicket">
        <div class="flex justifySB" style="gap: 1rem">
          <div class="date">{{ticket.get('createdAt') | amDateFormat: 'DD MMM, YY'}}</div>
          <div class="ticket-title"><a target="_blank" href="/chat/{{user.id}}" [ngClass]="{'clr-orange': ticket.get('status') == 'Pending'}">{{ticket.get('supportQuestion').get('question')}}</a></div>
        </div>
        <div class="flex pr-5" style="justify-content: space-between">
          <div class="sbar">{{ticket?.get('SBAR')?.get('situation')}}</div>
        </div>
      </div>
    </div>
  </div>
</div>